module.exports = __webpack_public_path__ + "img/top_banner.421fb9aa.png";